"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketSubscription = void 0;
const memcmp_1 = require("../memcmp");
class WebsocketSubscription {
    constructor({ orderSubscriber, skipInitialLoad = false, }) {
        this.orderSubscriber = orderSubscriber;
        this.skipInitialLoad = skipInitialLoad;
    }
    async subscribe() {
        if (this.websocketId) {
            return;
        }
        this.websocketId =
            this.orderSubscriber.driftClient.connection.onProgramAccountChange(this.orderSubscriber.driftClient.program.programId, (keyAccountInfo, context) => {
                const userKey = keyAccountInfo.accountId.toBase58();
                this.orderSubscriber.tryUpdateUserAccount(userKey, keyAccountInfo.accountInfo.data, context.slot);
            }, this.orderSubscriber.driftClient.opts.commitment, [(0, memcmp_1.getUserFilter)(), (0, memcmp_1.getNonIdleUserFilter)()]);
        if (!this.skipInitialLoad) {
            await this.orderSubscriber.fetch();
        }
    }
    async unsubscribe() {
        if (this.websocketId) {
            await this.orderSubscriber.driftClient.connection.removeProgramAccountChangeListener(this.websocketId);
            this.websocketId = undefined;
        }
    }
}
exports.WebsocketSubscription = WebsocketSubscription;
